import React, { useState, useEffect, useMemo } from 'react';
import { Button, Input, message, Table, InputNumber, AutoComplete } from 'antd';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import productService from '../../service/product.service';

const StyledButton = styled(Button)`
  margin-top: 16px;
  background-color: #012443;
  &:hover {
    background-color: #023d70ff !important;
  }
`;

const ProductTable = ({ product, onChange }) => {

    const [products, setProducts] = useState([
        createProducts(),
    ]);
    const [productsData, setProductsData] = useState([]);

    const navigate = useNavigate();

    // Formatação para exibição (totais, etc.) sempre com 2 casas decimais
    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === '') return '';

        let numberValue = typeof value === 'number' ? value : parseFloat(value);
        if (isNaN(numberValue)) return '';

        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(numberValue);
    };

    // Formatação específica para o InputNumber (não "briga" com a digitação)
    const formatCurrencyInput = (value) => {
        if (value === null || value === undefined || value === '') return '';

        const stringValue = value.toString();
        const [integerPart, decimalPart] = stringValue.split('.');
        const integerWithDots = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

        if (decimalPart !== undefined) {
            return `R$ ${integerWithDots},${decimalPart}`;
        }

        return `R$ ${integerWithDots}`;
    };

    const parseCurrency = (value) => {
        if (value === null || value === undefined || value === '') return '';
        if (typeof value === 'number') return value;

        return value
            .replace(/R\$\s?/g, '')
            .replace(/\./g, '')
            .replace(',', '.');
    };

    const calculateTotals = (product) => {
        const total = (product.amount || 0) * (product.priceList || 0);
        return {
            ...product,
            total,
            netPrice: total,
        };
    };

    useEffect(() => {
        if (product && product.length > 0) {
            setProducts(product);
        }
    }, [product]);

    useEffect(() => {
        if (onChange) {
            onChange(products);
        }
    }, [products]);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const snapshot = await productService.getProduct();
                setProductsData(snapshot);
            } catch (error) {
                message.error("Erro ao carregar os produtos. Tente novamente.");
                console.error(error);
            }
        };
        fetchProducts();
    }, []);

    function createProducts() {
        return {
            nameProducts: "",
            amount: "",
            priceList: "",
            total: "",
            netPrice: "",
        };
    };

    const productOptions = useMemo(() => [
        ...productsData.map(prod => ({
            value: prod.product,
        }))
    ], [productsData]);

    function handleChangeProducts(index, field, value) {
        const updatedProducts = [...products];
        updatedProducts[index][field] = value;
        if (field === 'amount' || field === 'priceList') {
            updatedProducts[index] = calculateTotals(updatedProducts[index]);
        }
        setProducts(updatedProducts);
        onChange && onChange(updatedProducts);
    };

    function handleAddProduct() {
        const newProducts = [...products, createProducts()];
        setProducts(newProducts);
        onChange && onChange(newProducts);
    };

    function handleRemoveProduct(index) {
        const updatedProducts = [...products];
        updatedProducts.splice(index, 1);
        setProducts(updatedProducts);
        onChange && onChange(updatedProducts);
    };

    return (
        <div>
            <Table pagination={false} dataSource={products} rowKey={(record, index) => index}>
                <Table.Column
                    title="Nome do Produto"
                    dataIndex="nameProducts"
                    key="nameProducts"
                    render={(text, record, index) => (
                        <AutoComplete
                        style={{ width: '100%' }}
                        options={productOptions}
                        value={record.nameProducts}
                        placeholder="Digite o nome do produto"
                        filterOption={(inputValue, option) =>
                            option.value.toUpperCase().includes(inputValue.toUpperCase())
                        }
                        onChange={(value) =>
                            handleChangeProducts(index, 'nameProducts', value)
                        }
                        >
                        <Input />
                        </AutoComplete>
                    )}
                />
                <Table.Column title="Quantidade" dataIndex="amount" key="amount"
                    render={(text, record, index) => (
                        <InputNumber
                            min={0}
                            precision={0}
                            value={record.amount}
                            onChange={(value) => handleChangeProducts(index, 'amount', value)}
                        />
                    )}
                />
                <Table.Column title="Valor Unitário" dataIndex="priceList" key="priceList"
                    render={(text, record, index) => (
                        <InputNumber
                            min={0}
                            precision={2}
                            controls={false}
                            formatter={formatCurrencyInput}
                            parser={parseCurrency}
                            value={record.priceList}
                            onChange={(value) => handleChangeProducts(index, 'priceList', value)}
                        />
                    )}
                />
                <Table.Column title="Valor Total" dataIndex="total" key="total"
                    render={(text, record, index) => (
                        <span>{formatCurrency(record.total)}</span>
                    )}
                />
                <Table.Column title="Ações" key="actions"
                    render={(text, record, index) => (
                        <Button
                            type="danger"
                            onClick={() => handleRemoveProduct(index)}
                            disabled={products.length === 1}
                            style={{ color: "red" }}
                        >
                            <DeleteOutlinedIcon />
                        </Button>
                    )}
                />
            </Table>
            <StyledButton type="primary" onClick={handleAddProduct}>
                Adicionar Produto
            </StyledButton>
            <span style={{marginLeft: "62%", marginTop: '16px', fontWeight: 'bold' }}>
                Total Geral: {formatCurrency(products.reduce((sum, prod) => sum + (prod.total || 0), 0))}
            </span>
        </div>
    );

};

export default ProductTable;